import { SwitchTiny } from "@/components"
import { BodyXs } from "@/domains/design/components/body-xs"

export const SwitchWithLabel = ({
  label,
  iconLeft,
  iconRight,
  checked,
  onCheckedChange,
}: {
  label: string
  iconLeft?: React.ReactNode
  iconRight?: React.ReactNode
  checked: boolean
  onCheckedChange: (value: boolean) => void
}) => {
  return (
    <div
      className="text-t200 flex w-fit cursor-pointer items-center gap-1.5 hover:brightness-[1.2]"
      onClick={() => onCheckedChange(!checked)}
    >
      {iconLeft}
      <BodyXs className="text-t300 text-nowrap">{label}</BodyXs>
      <SwitchTiny
        checked={checked}
        onCheckedChange={onCheckedChange}
        label=""
        id={label.toLowerCase().replace(" ", "-")}
      />
      {iconRight}
    </div>
  )
}
